export default __webpack_public_path__ + "static/media/bi.36e260ce.svg";